import {pickBy} from "lodash"


export const matchDOB = value => {
  let regex = /^(((0)[1-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/;
  let matches = value.match(regex);

  return matches !== null;
};

export const matchZipcode = value => {
  let regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
  let matches = value.toString().match(regex);

  return matches !== null;
}

export const messages = {
  name: "Name must be longer than 1 character",
  username: "Username must be longer than 1 character",
  location: "Location should be longer than 1 character",
  lastName: "Last Name must be longer than 1 character",
  gender: "Gender must be one of Male, Female, Other, or Prefer not to say",
  DOB: "Birthday must be in the format MM/DD/YYYY",
  zipCode: "Zip code must be 5 digits",
  default: "Answers to questions should be longer than 1 character"
};

export const rules = {
  name: value => value && value.length > 1,
  username: value => value && value.length > 1,
  location: value => value && value.length > 1,
  lastName: value => value && value.length > 1,
  gender: value => value && (["FEMALE", "MALE", "OTHER", "PREFER NOT TO SAY"].includes(value)),
  DOB: value => value && matchDOB(value),
  zipCode: value => value && matchZipcode(value),
  default: value => value && value.length > 1
};

export const validatedFields = [
  "name",
  "username",
  "location",
  "lastName",
  "gender",
  "DOB",
  "zipCode"
]

export const getValidatedFieldValues = (profileValues) => {

  let values = {...profileValues};

  return pickBy(values, (value,key) => {
     return validatedFields.includes(key);
  })
}

export const validate = (key, value) => {
  if (!rules[key]) {
    key = "default";
  }
  let hasError = !rules[key](value);

  if (hasError) {
    return messages[key];
  }

  return null;
};

export const getAvatar = (user, profile) => {
  const hasFbImage = user.picture !== null;
  const hasProfileImage = profile &&
    profile.avatarUrl && !profile.avatarUrl.includes("anonymous_user");

  if (hasProfileImage) {
    return profile.avatarUrl;
  } else if (hasFbImage) {
    return user.picture;
  }
  return profile.avatarUrl;
};


export const validator = (payload, onValidationCallback) => {
  let value = payload.value;
  const key = payload.name;
  const error = validate(key, value);

  const response = {
    key,
    error,
    value
  };

  onValidationCallback(response);
  
  return response;
};

export const formatDate = (date) => {
    let month = formatDateLL(date.getMonth()+1);
    let day = formatDateLL(date.getDate());
    let year = date.getFullYear()
    let newDate = `${month}/${day}/${year}`;
    return {name:"DOB", value:newDate}
}

// return date_num in two digits format, like '1' => '01'
const formatDateLL = (date_num) => {
    return date_num < 10 ? '0' + date_num.toString() : date_num.toString(); 
}

export const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
}
